import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';
import smartComponentsLoader from '../views/view-router/smartComponentsLoader';

Vue.use(VueRouter);

const routes = [
	{
		path: '/en/:path1?/:path2?/:path3?/:path4?/:path5?/:path6?/:path7?/:path8?/:path9?/',
		name: 'PageViewRouter_en',
		meta: { bodyClass: 'page' },
		component: smartComponentsLoader,
		props: true,
	},

	{
		path: '/ge/:path1?/:path2?/:path3?/:path4?/:path5?/:path6?/:path7?/:path8?/:path9?/',
		name: 'PageViewRouter_ge',
		meta: { bodyClass: 'page' },
		component: smartComponentsLoader,
		props: true,
	},

	{
		path: '/:path1?/:path2?/:path3?/:path4?/:path5?/:path6?/:path7?/:path8?/:path9?/',
		name: 'PageViewRouter_en',
		meta: { bodyClass: 'page' },
		component: smartComponentsLoader,
		props: true,
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	store,
	scrollBehavior(to, from, savedPosition) {
		// store.commit('setState', {key: 'offset', val: 0});
		if (window.innerWidth <= 768) {
			document.getElementById('main-layout')?.scrollIntoView();
		}
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth',
				offset: { x: 0, y: 0 },
			};
		} else {
			return { behavior: 'smooth', x: 0, y: 0 };
		}
	},
});

export default router;
